'use client';

import Sidebar from '@/components/Sidebar';
import SoDo from './components/SoDo';

export default function SoDoCongPage(props) {
  const { rightBanners, linkPages, websiteCode } = props;

  return (
    <div className="flex flex-col lg:flex-row gap-6">
      <section className="lg:w-3/4">
        <SoDo {...props} />
      </section>
      <section className="w-full md:w-1/4">
        <Sidebar rightBanners={rightBanners} linkPages={linkPages} websiteCode={websiteCode} />
      </section>
    </div>
  );
}
